import { Box, Typography, useTheme } from '@mui/material';
import { Button } from '../../../../shared/components/ui/Button';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

interface PageHeaderProps {
  onBack: () => void;
}

export function PageHeader({ onBack }: PageHeaderProps) {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Button onClick={onBack} sx={{ minWidth: 0, p: 0, mr: 1, color: theme.palette.text.primary, fontSize: 22 }}>
        <ArrowBackIosNewIcon />
      </Button>
      <Typography sx={{ color: theme.palette.text.primary, fontWeight: 800, fontSize: 26, letterSpacing: -1 }}>
        Visualizar Usuário
      </Typography>
    </Box>
  );
}